import { Box, Flex } from '@withjoy/joykit';
import { keyframes, pxToRem, styled, css } from '@withjoy/joykit/theme';

export const ScrollContainer = styled(Box)`
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    // Top fade
    rgba(0, 0, 0, 1) 30%,
    // Start full opacity
    rgba(0, 0, 0, 1) 70%,
    // End full opacity
    rgba(0, 0, 0, 0) // Bottom fade
  );
  mask-size: 100% 100%;
  mask-repeat: no-repeat;

  // For Safari
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0));
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
`;

// Define the scroll animation
const scroll = (scrollHeight: number) => keyframes`
  0% { transform: translateY(0); }
  100% { transform: translateY(-${pxToRem(scrollHeight)}); }
`;

const scrollWithPause = (scrollHeight: number, messageCount: number) => {
  const step = 100 / messageCount;
  const keyframeParts: string[] = [];

  for (let i = 0; i <= messageCount; i++) {
    const percent = i * step;
    const offset = pxToRem((scrollHeight / messageCount) * i);

    keyframeParts.push(`${percent}% { transform: translateY(-${offset}); }`);

    if (i < messageCount) {
      const pausePercent = percent + step / 2;
      keyframeParts.push(`${pausePercent}% { transform: translateY(-${offset}); }`);
    }
  }

  return keyframes`${keyframeParts.join('\n')}`;
};

// Inner list that scrolls

export const ScrollContent = styled(Flex)<{
  messageCount: number;
  scrollHeight: number;
  shouldPauseOnMessage?: boolean;
}>`
  ${({ scrollHeight, messageCount, shouldPauseOnMessage }) =>
    shouldPauseOnMessage
      ? css`
          animation: ${scrollWithPause(scrollHeight, messageCount)} ${messageCount}s linear infinite;
        `
      : css`
          animation: ${scroll(scrollHeight)} ${messageCount * 2}s linear infinite;
        `}
`;
